export default "__VITE_ASSET__DKnufJk2__"